import { render, staticRenderFns } from "./AdderDialog.vue?vue&type=template&id=2752c2a4&lang=pug&"
import script from "./AdderDialog.vue?vue&type=script&lang=js&"
export * from "./AdderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdderDialog.vue"
export default component.exports